// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myListsViewStyles } from "@insite/content-library/Widgets/MyLists/MyListsView";
import { fontConfig } from "@sc/XDL/PreStyle/typography";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

myListsViewStyles.select = {
    sizeVariant: "small",
    labelProps: {
        size: 14,
        lineHeight: "22px",
        weight: fontConfig.weight.regular,
        transform: "capitalize",
        css: css`
            width: fit-content;
            line-height: 22px;
            padding: 2px 8px 0 0;
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            width: 204px;
            ${xScreen("lte", "xs")} {
                width: 100%;
            }
        `,
        formField: css`
            row-gap: 4px;
        `,
    },
};
